import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setUserData } from 'common/redux/actions/userDataActions';
import { setUserAuthToken } from 'userAuth/redux/actions/authActions';
import { useAuthentication } from 'permissions/hooks';
import { authenticateDemoUser } from 'common/api/authenticationApi';
import isMobileViewActive from 'common/utils/viewUtils';
import { saveAuthData } from 'common/utils/authenticationUtils';

const useLandingAuthButtons = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isAuthenticated } = useAuthentication();

  const [loginStarted, setLoginStarted] = useState(false);

  useEffect(() => {
    if (loginStarted && isAuthenticated) {
      history.replace('/watchlist');
    }
  }, [loginStarted, isAuthenticated, history]);

  const pushAuthLocationWithRedirect = (redirectAfter) => {
    if (isAuthenticated) {
      history.push(redirectAfter);
    } else {
      history.push({
        pathname: isMobileViewActive() ? '/login' : '/auth',
        state: {
          redirectAfter,
        },
      });
    }
  };

  const loginDemo = () => {
    setLoginStarted(true);
    authenticateDemoUser().then((data) => {
      dispatch(setUserAuthToken(data.token));
      dispatch(setUserData(data.userData));
      saveAuthData(data.token, data.userData);
    });
  };

  return {
    loginDemo,
    isAuthenticated,
    loginStarted,
    pushAuthLocationWithRedirect,
  };
};

export default useLandingAuthButtons;
